import React from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
  Grid,
  // Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import GetAppIcon from "@mui/icons-material/GetApp";

const MobileRedirect = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, md: 5 },
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        <PhoneIphoneIcon sx={{ fontSize: 60, color: "primary.main", mb: 2 }} />

        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
          Please Use Our Mobile App
        </Typography>

        <Typography
          variant="body1"
          paragraph
          color="text.secondary"
          sx={{ mb: 4 }}
        >
          We've moved our services to our mobile application for a better
          experience. Please download the Bgdatalinks mobile app to continue
          using our services.
        </Typography>

        <Grid container spacing={3} justifyContent="center" sx={{ mb: 4 }}>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              size="large"
              startIcon={<GetAppIcon />}
              href="https://play.google.com/store/apps/details?id=com.bgdatalinks.mobile_app"
              target="_blank"
              rel="noopener"
            >
              Download for Android
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              startIcon={<GetAppIcon />}
              href="https://play.google.com/store/apps/details?id=com.bgdatalinks.mobile_app"
              target="_blank"
              rel="noopener"
            >
              Download for iOS
            </Button>
          </Grid>
        </Grid>

        <Box sx={{ mt: 2 }}>
          <Button
            variant="text"
            color="secondary"
            onClick={() => navigate("/")}
          >
            Back to Home Page
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default MobileRedirect;
